import React, { ChangeEvent, Dispatch, SetStateAction, useRef } from 'react';
import MDEditor, { commands } from '@uiw/react-md-editor';
import { usePostFile } from '../../../../traits/api/images/usePostFile';
import { toast } from '../../../../components/Toast';
import { UploadFileResponse } from '@ansvar-sakerhet/api-client';

import { S } from './MarkDownEditor.styles';

type Props = {
  value: string;
  setNewImages: Dispatch<SetStateAction<UploadFileResponse[]>>;
  onChange: (value: string) => void;
  onFocus: () => void;
};

export const MarkDownEditor: React.FC<Props> = (props) => {
  const selection = { start: 0, end: 0 };
  const inputRef = useRef<HTMLInputElement | null>(null);
  const uploadFile = usePostFile();

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    try {
      if (!event.target.files) return;
      const file = event.target.files[0];
      // allow only a-z, A-Z, 0-9, and . in the filename
      const fileName = file.name.replace(/[^a-zA-Z0-9.]/g, '');
      const renamedFile = new File([file], fileName, { type: file.type });

      const res = await uploadFile.mutateAsync(renamedFile);
      props.setNewImages((prev) => [...prev, res]);

      const url = res.url;
      if (url) {
        const str = `![image](${url})`;
        const newValue =
          props.value.substring(0, selection.start) +
          str +
          props.value.substring(selection.end);

        props.onChange(newValue);
      }
    } catch (err) {
      toast.error('Något gick fel när bilden skulle laddas upp');
    } finally {
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const customCommands = [
    commands.bold,
    commands.italic,
    commands.group(
      [
        commands.title1,
        commands.title2,
        commands.title3,
        commands.title4,
        commands.title5,
        commands.title6,
      ],
      {
        name: 'title',
        groupName: 'title',
        buttonProps: { 'aria-label': 'Insert title' },
      }
    ),
    commands.link,
    commands.unorderedListCommand,
    commands.orderedListCommand,
    // image,
  ];

  return (
    <>
      <MDEditor
        height={350}
        onFocus={props.onFocus}
        commands={customCommands}
        value={props.value}
        textareaProps={{
          placeholder: 'Skriv din nyhet här',
        }}
        preview="live"
        onChange={(value) => {
          if (value !== undefined) props.onChange(value);
        }}
      />
      <S.Button
        type="button"
        onClick={() => {
          if (inputRef.current) inputRef.current.click();
        }}
      >
        Ladda upp bild
      </S.Button>
      <S.Input type="file" ref={inputRef} onChange={handleFileChange} />
    </>
  );
};
